import { uploadProductsExcel } from '@gozoki/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import type { XlsxImportError } from '@gozoki/api-types'
import { AxiosError } from 'axios'
import { withRoutePermissions } from '~/utils/rbac'
import { XslxImport } from '../../../components/XslxImport'

export const Route = createFileRoute('/_authenticated/products/import')({
  staticData: {
    permission: ['import', 'products.products.product'],
  },
  component: ImportProductPage,
})
withRoutePermissions(Route)

function ImportProductPage() {
  const queryClient = useQueryClient()

  const { mutateAsync: mutateUploadProduct } = useMutation({
    mutationFn: uploadProductsExcel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product'] })
    },
  })

  return (
    <XslxImport
      onSubmit={async (file) => {
        try {
          const data = await mutateUploadProduct(file)
          return { data }
        } catch (error) {
          if (error instanceof AxiosError) {
            return { error: error.response?.data as XlsxImportError }
          }
          return { error: { errors: [], message: 'Une erreur inconnue est survenue' } }
        }
      }}
      resourceName="produit"
      helpText="Les feuilles « … par boutique » sont facultatives : cellule vide = date du produit, feuille absente = aucun changement."
      goBackRoute="/products"
    />
  )
}
